exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3f18172a!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/NotFound/NotFound.vue
// module id = 133
// module chunks = 0